import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './ImageUrlModal.scss'
import { Button, Modal, ModalHeader,
  ModalBody, ModalFooter, Form, FormGroup, Input
} from 'reactstrap'

class ImageUrlModal extends Component {
  onKeyDown = (synthetic, event) => {
    // return
    if (synthetic.keyCode === 13) {
      this.onSubmit(synthetic)
    }
  }

  onCancel = () => {
    this.props.toggle()
  }

  onSubmit = e => {
    e.preventDefault()

    this.onSelect({ src: this.inputsrc.value })

    this.props.toggle()
  }

  onSelect = (...args) => {
    this.props.onSelect(...args)
  }

  render () {
    return (
      <Modal isOpen={this.props.isOpen} size='lg' toggle={this.props.toggle} className={styles.ImageUrlModal}>
        <ModalHeader toggle={this.props.toggle}>Image URL</ModalHeader>
        <ModalBody onKeyDown={this.onKeyDown}>

          <Form name='ImageUrlForm' onKeyDown={this.onKeyDown}>

            <FormGroup>
              <Input type='text' name='src' id='image-src'
                placeholder='URL'
                onClick={e => e.stopPropagation()}
                getRef={input => { this.inputsrc = input }}
                autoFocus
                 />
            </FormGroup>

          </Form>

        </ModalBody>
        <ModalFooter>
          <Button form='ImageGalleryForm' color='primary' type='submit' onClick={this.onSubmit}>Save</Button>{' '}
          <Button form='ImageGalleryForm' color='secondary' onClick={this.onCancel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

ImageUrlModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default ImageUrlModal



// WEBPACK FOOTER //
// ./src/components/ImageUrlModal/ImageUrlModal.js